export default {
      id: "search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }